import { LocalStorageService } from './../../../../../core/services/local-storage.service';
import { EsnpermissionService } from './../../../../../core/services/esnpermission/esnpermission.service';
import { Component } from '@angular/core';
import {
  AbstractControl,
  FormArray,
  FormBuilder,
  FormGroup,
  Validators,
} from '@angular/forms';
import { Router } from '@angular/router';
import {
  serverError,
  successAddworkfloww,
} from './../../../../../core/models/messages';
import { ClientfinalCraService } from './../../../../../core/services/clientfinal-cra/clientfinal-cra.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-add-workflowclient',
  templateUrl: './add-workflowclient.component.html',
  styleUrls: ['./add-workflowclient.component.css'],
})
export class AddWorkflowclientComponent {
  formWorkFlow: FormGroup = this.createWorkFlowForm();
  company_id: any;
  listrole: any;
  currentStep: number = 1;
  name = [
    { id: '1', name: 'Consultant' },
    { id: '2', name: 'Responsable' },
    { id: '3', name: 'RH' },
  ];
  state = [
    { id: '1', name: 'Validé' },
    { id: '2', name: 'Rejeté' },
  ];

  list: { id: number; name: string }[] = [];
  private unsubscribeAll: Subject<void> = new Subject();
  constructor(
    private formBuilder: FormBuilder,
    private toastrService: ToastrService,
    private serviceCraclient: ClientfinalCraService,
    private spinner: NgxSpinnerService,
    private router: Router,
    private roleservice: EsnpermissionService,
    private localStorageService: LocalStorageService
  ) {}
  ngOnInit() {
    this.company_id = this.localStorageService.getData('clientConnected');
    this.getAllListClient();
    this.getListrole();
  }
  createWorkFlowForm(data?: any) {
    return this.formBuilder.group({
      company_id: [this.localStorageService.getData('clientConnected')],
      company_id_specific: [data?.company_id_specific || null],
      consultant_id: [data?.consultant_id || null],
      state_workflow: ['2'],
      subWorkFlowTimeSheets: this.formBuilder.array(
        Array.isArray(data?.subWorkFlowTimeSheets) &&
          data?.subWorkFlowTimeSheets.length
          ? data.subWorkFlowTimeSheets.map((item: any) =>
              this.createFormssubWorkFlows(item)
            )
          : [this.createFormssubWorkFlows()]
      ),
    });
  }
  createFormssubWorkFlows(data?: any) {
    return this.formBuilder.group({
      name: [data ? data.name : ''],
      state: [data ? data.state : null, [Validators.required]],
      custom_role_id: [
        data ? data.custom_role_id : null,
        [Validators.required],
      ],
      step: [data ? data.step : '1'],
    });
  }

  /* create workflow general*/
  createWorkflow() {
    this.spinner.show();
    this.serviceCraclient
      .createWorkFlowForm(this.formWorkFlow.value)
      .pipe(takeUntil(this.unsubscribeAll))
      .subscribe({
        next: (res) => {
          console.log('res', this.formWorkFlow.value);
          this.spinner.hide();

          this.toastrService.success(successAddworkfloww);
          this.formWorkFlow.reset();
          this.router.navigate(['/cra/workflow-Timesheet']);
          // this.closeModal()
        },
        error: (err) => {
          this.spinner.hide();
          if (err?.error) {
            if (err.error.message['name']) {
              // Swal.fire(this.toastMessages.error);
              // this.toastr.error(this.toastMessages.error);
            } else {
              this.toastrService.error(serverError);
            }
          }
        },
      });
  }
  addsubWorkFlows() {
    const subWork = this.formWorkFlow.get('subWorkFlowTimeSheets') as FormArray;
    const newSubWorkflow = this.createFormssubWorkFlows();
    const nextStepNumber = subWork.length + 1;
    newSubWorkflow.patchValue({
      step: nextStepNumber,
    });
    subWork.push(newSubWorkflow);
  }
  get subWorkFlowsControls(): AbstractControl<any, any>[] {
    return (
      (this.formWorkFlow.get('subWorkFlowTimeSheets') as FormArray)?.controls ||
      []
    );
  }
  removesubWorkFlows(index: number) {
    const subWorkFlows = this.formWorkFlow.get(
      'subWorkFlowTimeSheets'
    ) as FormArray;
    if (subWorkFlows.length > 1) {
      subWorkFlows.removeAt(index);
    }
  }
  ResetForm() {
    this.formWorkFlow.reset();
    // this.modalRef!.hide();
  }
  /* unsubscribe from api */
  ngOnDestroy() {
    this.unsubscribeAll.next();
    this.unsubscribeAll.complete();
  }
  getAllListClient() {
    this.spinner.show();
    let company_id = this.localStorageService.getData('clientConnected');
    this.serviceCraclient
      .getAllclientfinal(company_id)
      .pipe(takeUntil(this.unsubscribeAll))
      .subscribe({
        next: (res) => {
          this.spinner.hide();
          console.log('liste listclient', res);
          this.list = res.data;
          console.log('loggggglist', this.list);
        },
        error: () => {
          this.spinner.hide();
        },
      });
  }
  getListrole() {
    this.roleservice.getlisteroles(this.company_id).subscribe({
      next: (response) => {
        console.log('response', response);
        if (response.data) {
          this.listrole = response.data;
          console.log('list roles', this.listrole);
        }
      },
      error: (error) => {
        console.error('Error fetching roles: ', error);
      },
    });
  }
}
